import { FC } from 'react';
import { Button } from 'primereact/button';
import { Redo2, Undo2 } from 'lucide-react';
import { toast } from 'react-toastify';
import { fileRedoChanges, fileUndoChanges } from '@/api/services/File';

interface UndoRedoButtonsProps {
  fileUid: string;
  pageNumber: number;
  existsPreviousVersion: boolean;
  existsNextVersion: boolean;
  refetch: () => Promise<void>;
  isDisabled: boolean;
}

const UndoRedoButtons: FC<UndoRedoButtonsProps> = ({
  fileUid,
  pageNumber,
  existsPreviousVersion,
  existsNextVersion,
  refetch,
  isDisabled,
}) => {
  const undoChanges = async () => {
    try {
      const response = await fileUndoChanges(fileUid, pageNumber - 1);
      if (response.status === 200 || response.status === 202) {
        toast.success('Změny byly úspěšně vráceny.');
        await refetch();
      }
    } catch (error: any) {
      if (error?.response?.data?.detail) {
        toast.error(`Error: ${error.response.data.detail}`);
      } else {
        toast.error(`Chyba při vracení změn.`);
      }
    }
  };

  const redoChanges = async () => {
    try {
      const response = await fileRedoChanges(fileUid, pageNumber - 1);
      if (response.status === 200 || response.status === 202) {
        toast.success('Změny byly znovu provedeny.');
        await refetch();
      }
    } catch (error: any) {
      if (error?.response?.data?.detail) {
        toast.error(`Error: ${error.response.data.detail}`);
      } else {
        toast.error(`Chyba při znovu provádění změn.`);
      }
    }
  };

  return (
    <div className="flex justify-between gap-2 mt-2 items-center py-1.5 px-2 border border-b-0 border-[#dddddd] bg-[#f2f2f2]">
      {existsPreviousVersion && (
        <Button
          icon={<Undo2 size={16} />}
          text={true}
          onClick={undoChanges}
          tooltip={'Vrátit změny'}
          tooltipOptions={{ position: 'top' }}
          className={'text-md focus:shadow-none'}
          disabled={isDisabled}
        />
      )}
      {existsNextVersion && (
        <Button
          icon={<Redo2 size={16} />}
          text={true}
          onClick={redoChanges}
          tooltip={'Znovu provést změny'}
          tooltipOptions={{ position: 'top' }}
          className={'text-md focus:shadow-none ml-auto'}
          disabled={isDisabled}
        />
      )}
    </div>
  );
};

export default UndoRedoButtons;
